export function numeralForm(num: number, forms: string[]): string {
  if (!forms.length) {
    return '';
  }
  if (forms.length === 1) {
    return forms[0];
  }
  const h = num % 100;
  const tens = Math.trunc((h - h % 10) / 10);
  const units = num % 10;
  let f = 2;
  if (units === 1 && tens !== 1) {
    f = 0;
  } else if (units > 1 && units < 5 && tens !== 1) {
    f = 1
  }
  if (f > forms.length - 1) {
    f = forms.length - 1;
  }
  return forms[f];
}

export const format2digs = new Intl.NumberFormat('en-US', {style: 'decimal', minimumIntegerDigits: 2}).format;

export const format2DigitsVariant = new Intl.NumberFormat('ru-RU', {style: 'decimal', useGrouping: false, maximumFractionDigits: 2})
export const format2DigitsVariantNotUseGrouping = new Intl.NumberFormat('ru-RU', {style: 'decimal', useGrouping: false, maximumFractionDigits: 2})

export const format5DigitsVariant = new Intl.NumberFormat('ru-RU', {style: 'decimal', maximumFractionDigits: 5})

export function numericalSort(a: number, b: number): number {
  return a - b;
}
